import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-jquiselectable',
	templateUrl:'./JQUISelectablePage.html',
	styles: [],
	styleUrls:['./JQUISelectablePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class JQUISelectablePage
{
	mdContent_216 = `\`\`\`java
import com.jwebmp.plugins.jqueryui.selectable.JQUISelectable;
\`\`\``;
	mdContent_217 = `\`\`\`java
new JQUISelectable&lt;&gt;()
\`\`\``;
	mdContent_218 = `\`\`\`java
var list = new JQUISelectable<>();
list.addItem("Item 1");
list.addItem("Item 2");
list.addItem("Item 3");
\`\`\``;
}
